<template>
  <div class="email-input-container">
    <v-text-field
      type="email"
      :label="label"
      :placeholder="placeholder || 'Enter an email address'"
      v-model="emailValue"
      @change="handleChange"
      density="compact"
      autocomplete="off"
      :disabled="disabled"
      :error-messages="errorMessages"
      hide-details="auto"
    >
      <template v-if="requireEmail" v-slot:append-inner>
        <div class="checkbox-wrapper d-flex align-center">
          <v-btn
            icon
            variant="text"
            density="compact"
            @click="toggleRefusedEmail"
            :disabled="disabled"
            class="mr-1"
          >
            <v-icon
              :color="disabled ? 'grey' : 'primary'"
              :icon="
                refusedEmail
                  ? 'mdi-checkbox-marked-outline'
                  : 'mdi-checkbox-blank-outline'
              "
            />
          </v-btn>
          <span
            class="refused-label"
            @click="toggleRefusedEmail"
            :class="{ 'text-disabled': disabled }"
          >
            Refused to Give
          </span>
        </div>
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'VuetifyEmailInput',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Email',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    requireEmail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emailValue: this.modelValue,
      refusedEmail: false,
    };
  },
  computed: {
    errorMessages() {
      if (this.requireEmail && !this.emailValue && !this.refusedEmail) {
        return ['Must enter email or refused to give'];
      }
      return [];
    },
  },
  watch: {
    modelValue(newVal) {
      this.emailValue = newVal;
    },
  },
  methods: {
    handleChange() {
      this.$emit('update:modelValue', this.emailValue);
      this.$emit('change', this.emailValue);
    },
    toggleRefusedEmail() {
      if (!this.disabled) {
        this.refusedEmail = !this.refusedEmail;
        this.handleRefusedChange();
      }
    },
    handleRefusedChange() {
      this.$emit('update:refused-email', this.refusedEmail);
      this.$emit('change-refused', this.refusedEmail);
    },
  },
};
</script>

<style scoped>
.email-input-container {
  position: relative;
}

.checkbox-wrapper {
  white-space: nowrap;
  align-items: center;
}

.refused-label {
  cursor: pointer;
  user-select: none;
  margin-left: 4px;
}

.refused-label:hover {
  text-decoration: underline;
}

.refused-label.text-disabled {
  color: rgba(0, 0, 0, 0.38);
  cursor: default;
  text-decoration: none;
}
</style>
